<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-4 font-weight-regular">
        <div class="pl-4" style="font-size: 16px">
          <v-row no-gutters>
            <v-col cols="12" class="pb-0">
              <span class="text-strong">Dados do Cliente:</span>
            </v-col>
            <v-col cols="4">
              <span class="text-label">Documento Federal: </span>
              {{model.Cliente.DocumentoFederal}}
            </v-col>
            <v-col cols="8">
              <span class="text-label">Razão Social: </span>
              {{model.Cliente.Nome}}
            </v-col>
          </v-row>

          <v-row no-gutters class="mt-5">
            <v-col cols="12" class="pb-0">
              <span class="text-strong">Operação de Crédito:</span>
            </v-col>
            <v-col cols="6">
              <span class="text-label">Tipo de Operação: </span>
              {{ model.TipoOperacaoNome}}
            </v-col>
            <v-col cols="6">
              <span class="text-label">Produto:</span>
              {{model.TipoContratoDescricao}}
            </v-col>
          </v-row>

          <v-row class="mt-5" no-gutters>
            <v-col cols="12">
              <span class="text-strong">Dados da Operação de Crédito: </span>
            </v-col>
            <v-col cols="12">
              <div class="item-value">
                <span class="text-value-label">Valor Líquido Solicitado: </span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrSolicitado)}}</span>
              </div>

              <div class="item-value">
                <span class="text-value-label">Tarifa de Cadastro: </span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTAC)}}</span>
              </div>

              <template v-if="model.OutrosServicos">
                <div class="item-value" v-if="model.VlrSeguro > 0">
                  <span class="text-value-label">Seguro: </span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrSeguro || 0)}}</span>
                </div>

                <div class="item-value" v-if="model.VlrAvaliacao > 0">
                  <span class="text-value-label">Tarifa de Avaliação: </span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrAvaliacao || 0)}}</span>
                </div>

                <div class="item-value" v-if="model.VlrVistoria > 0">
                  <span class="text-value-label">Tarifa de Vistoria: </span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrVistoria || 0)}}</span>
                </div>

                <div class="item-value" v-if="model.VlrOutrasDespesas > 0">
                  <span class="text-value-label">Tarifa de Registro CETIP: </span>
                  <span class="text-value">{{ $api.UI.Format.Currency(model.VlrOutrasDespesas || 0)}}</span>
                </div>
              </template>

              <div class="item-value" v-if="model.VlrRegistro > 0">
                <span class="text-value-label">Valor do Registro: </span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrRegistro)}}</span>
              </div>

              <div class="item-value">
                <span class="text-value-label">Valor Total Solicitado: </span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalSolicitado)}}</span>
              </div>

              <div class="item-value">
                <span class="text-value-label">IOF: </span>
                <span class="text-value">{{ $api.UI.Format.Currency(model.VlrIOF)}}</span>
              </div>
            </v-col>

            <v-col cols="6" class="item-value my-2 font-weight-bold">
              <span class="text-value-label">Valor Total Financiado: </span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalFinanciado)}}</span>
            </v-col>
            <v-col cols="6" class="item-value my-2 font-weight-bold">
              <span class="text-value-label">Prestações: </span>
              <span class="text-value">{{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento)}} até {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}</span>
            </v-col>

            <v-col cols="6" class="item-value font-weight-bold">
              <span class="text-value-label">Número de Prestações: </span>
              <span class="text-value">{{ model.Prazo }}</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Valor da Prestação: </span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal)}}</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Taxa de Juros: </span>
              <span class="text-value">{{ $api.UI.Format.Decimal(model.PercJurosMensal)}}% a.m.</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">CET: </span>
              <span class="text-value">{{ $api.UI.Format.Decimal(model.PercCETMensal)}}% a.m.  /  {{ $api.UI.Format.Decimal(model.PercCETAnual) }}% a.a.</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Amortização: </span>
              <span class="text-value">{{ model.ModeloCalculo === $api.Voltz.ModeloCalculoEnum.Price ? 'Price' : 'SAC'}}</span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-value-label">Modalidade: </span>
              <span class="text-value">Pré-Fixado</span>
            </v-col>
            <v-col cols="6" class="item-value" v-if="model.TipoIndexador === 2">
              <span class="text-value-label">Indexador: </span>
              <span class="text-value">{{ indexador }} </span>
            </v-col>

            <v-col cols="12" class="mt-5">
              <span class="text-strong">Prestações: </span>
            </v-col>
            <v-col cols="6" class="item-value">
              <span class="text-label-1">1º Prestação</span>
              <span class="text-value">
                Data: {{ $api.UI.Format.Date(model.PrimeiraParcela.DtVencimento) }}<br />
                Valor: {{ $api.UI.Format.Currency(model.PrimeiraParcela.VlrPrestacaoTotal) }}
                {{ model.TipoIndexador === 2 ? `+ ${model.PercIndiceFinan}% do índice ${indexador}` : ''}}
              </span>
            </v-col>

            <v-col cols="6" class="item-value">
              <span class="text-label-1">Última Prestação</span>
              <span class="text-value">
                Data: {{ $api.UI.Format.Date(model.UltimaParcela.DtVencimento) }}  <br />
                Valor: {{ $api.UI.Format.Currency(model.UltimaParcela.VlrPrestacaoTotal) }}
                {{ model.TipoIndexador === 2 ? `+ ${model.PercIndiceFinan}% do índice ${indexador}` : ''}}
              </span>
            </v-col>

            <v-col cols="6" class="item-value mt-5">
              <span class="text-label-1 font-weight-bold">Valor Total da Dívida</span>
              <span class="text-value">{{ $api.UI.Format.Currency(model.VlrTotalDivida)}}</span>
            </v-col>
          </v-row>
        </div>
        <v-row>
          <v-col cols="12" class="pl-4 pb-0 mt-6 d-flex justify-center">
            <span style="font-size: 16px" class="text-strong">Fluxo de Pagamento</span>
          </v-col>
          <v-col cols="12" class="px-2 pt-0">

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-center"> Parcela </th>
                    <th class="text-center"> Vencimento  </th>
                    <th class="text-right"> Prestação </th>
                    <!--<th class="text-right">  Amortização  </th>
                    <th class="text-right"> Juros   </th>-->
                    <th class="text-right">  Saldo Devedor </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="model.Parcelas.length === 0">
                    <td colspan="4" class="text-center text--disabled">Aguardando geração das parcelas</td>
                  </tr>
                  <tr v-for="(item, index) in model.Parcelas" :key="index">
                    <template v-if="index < 3 || verTodasParcelas">
                      <td class="text-center">{{ (item.NumeroParcela || index) + 1 }}</td>
                      <td class="text-center">{{ $api.UI.Format.Date(item.DtVencimento) }}</td>
                      <td class="text-right">{{ $api.UI.Format.Currency(item.VlrPrestacaoTotal) }}</td>
                      <!--<td class="text-right">{{ item.VlrAmortizacao !== null ? $api.UI.Format.Currency(item.VlrAmortizacao) : '-' }}</td>
                      <td class="text-right">{{ item.VlrJurosAcumulado !== null  ? $api.UI.Format.Currency(item.VlrJurosAcumulado) : '-' }}</td>-->
                      <td class="text-right">{{ item.VlrSaldoDevedor !== null  ? $api.UI.Format.Currency(item.VlrSaldoDevedor) : '-' }}</td>
                    </template>
                    <td role="button" v-else-if="index === 3" colspan="4"
                        class="text-center text-decoration-underline primary--text" @click="verTodasParcelas = true">
                      ver todas as parcelas
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>

        <template v-if="resumoProposta && isLoaded">
          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos do Emitente</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Pessoa" resumo :codigoProposta="model.Codigo" :codigoPessoa="model.CodigoCliente" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Documentos da Proposta</span>
            </v-col>
            <v-col cols="12">
              <DocumentoGrid :tipo="$aux.TipoDocumentoEntidade.Proposta" resumo :codigoProposta="model.Codigo" :key="model.Codigo"/>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Garantidores</span>
            </v-col>
            <v-col cols="12">
              <PropostaAvalista resumo :value="model"></PropostaAvalista>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="pb-0 mt-6">
              <span class="text-subtitle-1">Garantias</span>
            </v-col>
            <v-col cols="12">
              <PropostaGarantia resumo :value="model"></PropostaGarantia>
            </v-col>
          </v-row>
        </template>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  components: {
    PropostaAvalista: () => import('@/views/proposta/PropostaAvalista.vue'),
    PropostaGarantia: () => import('@/views/proposta/PropostaGarantia.vue'),
  },
  props: {
    resumoProposta: { type: Boolean, default: false },
    modal: { type: Boolean, default: false }
  },
  data () {
    return {
      model: {
        Cliente: {},
        Parcelas: {},
        PrimeiraParcela: {},
        UltimaParcela: {}
      },
      isLoaded: false,
      verTodasParcelas: false
    };
  },
  computed: {
    indexador () {
      const th = this
      return th.$api.Voltz.Indexador.find(p => p.value === th.model.TipoIndiceFinan)?.text
    }
  },
  methods: {
    load (model) {
      this.isLoaded = false
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model)
      this.$nextTick(() => {
        this.isLoaded = true
      })
    }
  }
}

</script>

<style>
  #resumo-proposta span.text-label-1 {
    display: block;
  }

  #resumo-proposta span.text-label {
    margin-right: 2px
  }

  #resumo-proposta span.text-strong {
    font-weight: 600;
  }
  #resumo-proposta span.text-value-label, #resumo-proposta span.text-subtitle-1 {
    margin-right: 2px
  }

  #resumo-proposta span.text-value {
    text-align: end;
  }
</style>
